<template>
  <div>
    <div id="login">
      <div class="coment">
        <h1>
          <img src="../assets/images/logo-kakao-vx.svg" style="width: 200px" />
        </h1>
      </div>
      <div class="login-box">
        <div class="inner">
          <v-form ref="form" v-model="valid">
            <div class="mb-3">
              <p class="label">아이디</p>
              <v-text-field
                class="input-custom-2"
                height="36px"
                v-model="user_id"
                :rules="idRules"
                solo
                required
              ></v-text-field>
            </div>

            <div class="mb-3">
              <p class="label">비밀번호</p>
              <v-text-field
                class="input-custom-2"
                type="password"
                height="36px"
                v-model="password"
                :rules="passwordRules"
                solo
                required
                :error-messages="loginPasswordErrorMessage"
              ></v-text-field>
            </div>
          </v-form>
          <div class="mb-3">
            <p class="label">인증코드</p>
            <v-text-field
              class="input-custom-2"
              height="36px"
              v-model="authorize_code"
              :rules="codeRules"
              solo
            ></v-text-field>
          </div>
          <v-btn
            large
            depressed
            block
            max-height="48px"
            color="#fecd06"
            @click.prevent="submitForm"
            :disabled="!valid"
          >
            로그인
          </v-btn>
          <p class="login-lost">
            아이디 및 비밀번호를 모르시나요?
            <a href="mailto:_advx@kakaovx.com">문의하기</a>
          </p>
        </div>
      </div>
      <div class="login-foot">
        <p class="logo">
          <img
            src="../assets/images/logo-kakao-vx-foot.png"
            srcset="
              ../assets/images/logo-kakao-vx-foot@2x.png 2x,
              ../assets/images/logo-kakao-vx-foot@3x.png 3x
            "
          />
          <span class="foot-coment type1 ml-3">
            Copyright © Kakao VX Corp. All rights reserved.
          </span>
        </p>

        <p class="foot-coment type2">
          광고 집행 및 문의사항은 "<a
            href="http://www.kakaovx.com/advertisement.html"
            target="_blank"
            >광고 안내 페이지</a
          >" 에서 확인하실 수 있습니다.
        </p>
      </div>
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { validatePasword } from '@/utils/validation';
import SystemAlert from '~@/modal/SystemAlert.vue';
export default {
  components: {
    SystemAlert,
  },
  name: 'login',
  data: () => ({
    valid: false,
    user_id: '',
    idRules: [
      v => !!v || '아이디를 입력해주세요.',
      v =>
        (v && /^[A-Za-z0-9]{6,20}$/.test(v)) ||
        '6~20자 영문/숫자만 사용 가능합니다.',
    ],
    password: '',
    passwordRules: [v => !!v || '비밀번호를 입력해주세요.'],
    authorize_code: '',
    codeRules: [
      v => !!v || '',
      v => (v && v.length <= 8 && v.length >= 8) || '잘못된 인증코드 입니다!',
    ],
    user_eamil: '',
    adviertier: '',
    userIdErrorMessage: '',
    authCodeErrorMessage: '',
    errorMessage: '',
    showSystemAlert: false,
    logResult: '',
  }),
  computed: {
    loginPasswordErrorMessage() {
      let str = '';
      if (this.password && !validatePasword(this.password)) {
        str =
          '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
      }
      return str;
    },
  },
  watch: {
    // isUserIdVaid() {
    // 	return validateEmail(this.user_eamil);
    // },
    //validate() {
    //	return this.$refs.form.validate();
    //},
  },
  methods: {
    async submitForm() {
      bus.$emit('start:spinner');
      try {
        const userData = {
          user_id: this.user_id.replace(/\s/g, ''),
          password: this.password.replace(/\s/g, ''),
          authorize_code: this.authorize_code.replace(/\s/g, ''),
        };
        await this.$store.dispatch('LOGIN', userData);
        this.$router.push('/');
        bus.$emit('end:spinner');
      } catch (error) {
        console.log('error', error);
        const { data } = error.response;
        if (data.result === 'DoesNotExist' && data.data === 'account') {
          this.logResult = '아이디를 확인해주세요!';
        } else if (data.result === 'ParameterValidation') {
          if (data.data === 'password') {
            this.logResult = '비밀번호를 확인해주세요!';
          } else {
            this.logResult = '잘못된 인증코드 입니다!';
          }
        } else if (data.result === 'DoesNotHavePermission') {
          this.logResult = '권한이 비활성화된 계정입니다.';
        } else if (data.result === 'DisabledUser') {
          this.logResult = '비활성화된 계정입니다.';
        } else if (data.result === 'TooManyFailed') {
          this.logResult =
            '로그인 실패가 5회, 보안목적 차단됩니다.<br/>VX담당자에게 문의해주시기 바랍니다.';
        } else if (data.result === 'TooOldPassword') {
          this.logResult =
            '기존 비밀번호가 180일 이상 사용중입니다.<br/>VX담당자에게 문의해주시기 바랍니다. ';
        } else if (data.result === 'TooSeldomLogin') {
          this.logResult =
            '마지막 접속 후 90일 경과로 잠금처리되었습니다.<br />VX담당자에게 문의해주시기 바랍니다.';
        } else {
          this.logResult =
            '로그인 중 에러가 발생했습니다. 재시도 부탁드립니다.';
        }
        this.showSystemAlert = true;
      }
    },
    async formValidationReset() {
      await this.$refs.form.resetValidation();
      this.valid = true;
    },
    //clearUserIdErrorMessage() {
    //	this.userIdErrorMessage = '';
    //},
    //clearPasswordErrorMessage() {
    //	this.passWordErrorMessage = '';
    //},
    //clearAuthCodeErrorMessage() {
    //	this.authCodeErrorMessage = '';
    //},
    closePopup() {
      this.showSystemAlert = false;
      this.logResult = '';
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;

  .coment {
    padding-top: 140px;
    color: #4c4c4c;
    font-size: 40px;
    font-weight: 700;
  }

  .login-box {
    flex: 1;
    margin-top: 40px;

    .inner {
      width: 400px;
      padding: 24px 24px 32px;
      border-radius: 4px;
      box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.05);
      background-color: #fff;

      .label {
        margin-bottom: 8px;
        color: #4c4c4c;
        font-size: 13px;
        font-weight: 700;
      }

      .login-lost {
        margin: 24px 0 32px;
        color: #000;
        font-size: 13px;
        text-align: center;
        a {
          margin-left: 4px;
          color: #3c77ff;
          font-size: 13px;
        }
      }
    }
  }

  .login-foot {
    position: relative;
    width: 100%;
    height: 80px;
    padding: 30px 0 0 0;
    background-color: #fff;
    text-align: center;

    .logo {
      position: absolute;
      top: 32px;
      left: 53px;
    }

    .foot-coment {
      color: #999;
      font-size: 13px;

      a {
        color: #3c77ff;
        text-decoration: underline;
      }
      &.type1 {
        position: relative;
        top: -2px;
      }
      &.type2 {
        position: relative;
        top: 2px;
      }
    }
  }
}
</style>
